import React, { Component, Fragment, useEffect, useState } from 'react';

import HomeLayout from '../../../containers/HomeLayout';
import ChatInput from './ChatInput';
import Messages from './Messages';
import '../../../assets/css/style.css';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../store/actions/messageActions';
import * as profileActions from '../../../store/actions/profileActions';
import * as signalR from '@microsoft/signalr';
import { Link } from 'react-router-dom';


const baseUrl = process.env.NODE_ENV === 'development' ? 
    process.env.REACT_APP_DEV_API_BASE_URL : process.env.REACT_APP_PROD_API_BASE_URL;

const ConversationRoom = props => {
    const initialValues = {
        userId: null,
        profileName: '',
        dateOfBirth: '',
        gender: '',
        profilePhotos: [],
        universityInfo: { campus: '', faculty: '' },
        interests: [],
        virtue: {
            genderPreference: '', ethnicity: '', religion: '', politicalView: '',
            smoking: '', drinking: '', height: ''
        },
        bio: '',
        isActive: true,
        profilePrompts: []
    }
    const [otherProfile, setOtherProfile] = useState(initialValues)
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();
    const hubConnection = new signalR.HubConnectionBuilder().withUrl(`${baseUrl}/message`).build();
    hubConnection.start();

    const getMessageRoom = () => {
        var users = [profileState.userProfile.profileName.split(" ").join(""), props.match.params.user.split(" ").join("")];
        console.log(users);
        users.sort((a, b) => {
            if(a < b){
                return -1;
            }
            else if (a > b) {
                return 1
            }
            return 0;
        })

        return users.join('-');
    }

    const onSendMessage = (text) => {
        var message = {messageRoom: getMessageRoom(), profileId: profileState.userProfile.profileId, messageText: text, messageDateTime: new Date()};
        dispatch(actions.sendMessage(message));
    }
    
    return (
        <HomeLayout>
            <div className="chat-screen">
                <div className="chat-name-row">
                    <Link to="/conversations">
                        <i className="fa fa-chevron-left"></i>
                    </Link>
                    <p className="chat-name">
                        {props.match.params.user}
                    </p>
                </div>
                <Messages hubConnection={hubConnection} currentMember={profileState.userProfile} getMessageRoom={getMessageRoom} />
                <ChatInput onSendMessage={onSendMessage} />
            </div>
        </HomeLayout>
    );
}

export default ConversationRoom;